export const PUT_HOUSEHOLD_METADATA = 'PUT_HOUSEHOLD_METADATA';
export const SET_LOADING = 'SET_LOADING';
